import { Layer } from './layer';
import { Solution } from './solution';
import { Stream } from './domain/stream';
import { Design } from './domain/design';

export class LayerObject {
    layer: Layer;
    flows: Array<Stream>;
    maps: Array<Design>;
    solutions: Array<Solution>;

//    private transient List<Solution> solutions;

    error_Cd: string;
    error_Msg: string;

    constructor() {
        this.flows = new Array<Stream>();
        this.maps = new Array<Design>();
        this.layer = new Layer();
        this.error_Cd = '0';
        this.error_Msg = '';
        this.solutions = new Array<Solution>();
    }

}